import {useEffect,useState} from 'react';
import {api} from '../api/client';
export function useLessonReviewMode(active=true,scope=''){
 const [state,setState]=useState({enabled:false,known:false,error:''});
 useEffect(()=>{if(!active){setState({enabled:false,known:false,error:''});return;}
 let alive=true,busy=false;setState({enabled:false,known:false,error:''});
 const load=async()=>{if(busy)return;busy=true;try{const result=await api.lessonMonitor.get('review');if(alive)setState({...result,known:true,error:''});}catch(error){if(alive)setState(old=>({...old,error:'Review settings could not be refreshed. Please retry before starting.'}));}finally{busy=false;}};
 load();const id=window.setInterval(load,2500);window.addEventListener('focus',load);return()=>{alive=false;clearInterval(id);window.removeEventListener('focus',load);};
 },[active,scope]);return state;
}
